import React, { Fragment, useEffect, useState, useRef } from "react";
import { Card, Table, Form, Button, Row, Col, Container } from "react-bootstrap";
import { formato_monto, isValidParam, formatearNumero, validaNumeros } from '../../common/Formatos'
import { serviceMediosPago, serviceGetBancos, serviceRendirCuota } from '../../api/api-rendicion-pago-cuotas';
import Mensajes from '../mensajes'
import { useLocation, useNavigate } from 'react-router-dom'
import {useFormik} from 'formik'
import { validationSchemas } from '../../common/validation-Schemas-rendicion-pago-cuotas'
import { Auth } from 'recupero-comunes';
import { LoadingComponent } from 'recupero-comunes';
import { ESTADO_CUOTA_DECLARADA, ESTADO_CUOTA_RENDIDA_PARCIAL, ESTADO_CUOTA_VISADA_PARCIAL } from '../../common/constants';
import { useSelector } from 'react-redux'

const RendicionCuotas = ({cfg_form, declaracionPago, getDeclaracionPago}) => {
    
    const [loading, setLoading] = useState(false);

    const data_areaBuscar = useSelector((state) => state.areaBusquedaCasosIngresoRecuperoReducer)
    const {llaves} = data_areaBuscar

    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    const [montoRendidoNoFormato, setMontoRendidoNoFormato] = useState('')
    const [cuotasSeleccionadas, setCuotasSeleccionadas] = useState([]);
    const [respuestaRendir, setRespuestaRendir] = useState({});
    const [mensajeBloqueo, setMensajeBloqueo] = useState('');

    const queryState=JSON.parse(localStorage.getItem('filtrosAreaIngresoCuotas'))
    const history =useNavigate()

    const fileRefComprobante = useRef();
    const [fechaMin, setFechaMin]=useState('')

    const [montoRendido, setMontoRendido] = React.useState('')
    const [medioPago, setMedioPago] = React.useState('')
    const [banco, setBanco] = React.useState('')
    const [nroChequeTrx, setNroChequeTrx] = React.useState('')
    const [fechaTransaccion, setFechaTransaccion] = React.useState('')

    const [cuotasPendientes, setCuotasPendientes] = useState([]);

    const [mediosPago, setMediosPago] = useState([]);
    const [bancos, setBancos] = useState([]);

    const [codMoneda, setCodMoneda] = useState(0)
    const [totalARendir, setTotalARendir] = useState(0);

    const [montosPago, setMontosPago] = useState({});
    const [montosDisplay, setMontosDisplay] = useState({});
    const [montoSaldoCuotas, setMontoSaldoCuotas] = useState(0);
    const [valorParamToleranciaMonto, setValorParamToleranciaMonto] = useState(0.1);

    useEffect(()=>{
        if(respuestaRendir && respuestaRendir["code"]===1){
            setTimeout(()=> history('/area-ingreso-recuperos-cuota',{state:{queryState}}),3000)      
        }
    },[respuestaRendir])

    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    
    useEffect(() => {
        if (declaracionPago && declaracionPago['cuotas']) {
            let pendientes = declaracionPago['cuotas'].filter(c =>
                (c.codEstadoCuota === ESTADO_CUOTA_DECLARADA ||
                 c.codEstadoCuota === ESTADO_CUOTA_RENDIDA_PARCIAL ||
                 c.codEstadoCuota === ESTADO_CUOTA_VISADA_PARCIAL) &&
                parseFloat(c.montoRendidoTotal || 0) < parseFloat(c.montoCuota)
            );
            setCuotasPendientes(pendientes);

            getMediosPago();

            setCodMoneda(declaracionPago['codMonedaLocal']);

            setMontoSaldoCuotas(declaracionPago['saldoCuotas']);
            setValorParamToleranciaMonto(declaracionPago['paramToleranciaMonto'] || 0.1);

            const cuotaParcial = pendientes.find(c =>
                c.codEstadoCuota === ESTADO_CUOTA_RENDIDA_PARCIAL || c.codEstadoCuota === ESTADO_CUOTA_VISADA_PARCIAL
            );
            if (cuotaParcial) {
                const montoAcumulado = parseFloat(cuotaParcial.montoRendidoTotal) || 0;
                const saldo = parseFloat(cuotaParcial.montoCuota) - montoAcumulado;
                setMontosPago({ [cuotaParcial.nroCuota]: saldo });
                setMontosDisplay({ [cuotaParcial.nroCuota]: saldo ? formatearNumero(saldo) : '' });
                setCuotasSeleccionadas([cuotaParcial.nroCuota]);
                setTotalARendir(saldo);
                formik.setFieldValue('cuotasSeleccionadas', [cuotaParcial.nroCuota], false);
            }
        }
    }, [declaracionPago]);

    const getMediosPago = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 53 })).toString('base64');
        const response = await serviceMediosPago(query);

        setMediosPago(response);
    }
    const getBancos = async (value) => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves && llaves['idCaso']})).toString('base64');
        if (value == 53002 || value == 53003) {
            query = Buffer.from(JSON.stringify({rutOrganizacion: llaves && llaves['idOrgCaso']})).toString('base64')
        }
        const response = await serviceGetBancos(query);

        setBancos(response);
    }

    const toggleSeleccion = (cuotaId) => {
        setMensajeBloqueo('');

        const nuevaSeleccion = cuotasSeleccionadas.includes(cuotaId)
        ? cuotasSeleccionadas.filter((id) => id !== cuotaId)
        : [...cuotasSeleccionadas, cuotaId].sort((a, b) => a - b);

        // Validar orden secuencial a partir de la primera cuota pendiente
        const primeraCuota = cuotasPendientes[0]?.nroCuota;
        const esSecuencial = nuevaSeleccion.every((id, index) => id === primeraCuota + index);

        if (!esSecuencial) {
            setMensajeBloqueo("Debes seleccionar las cuotas en orden.");
            return;
        }

        // La cuota anterior debe tener su pago completo antes de seleccionar la siguiente
        if (!cuotasSeleccionadas.includes(cuotaId)) {
            const cuotaAnterior = nuevaSeleccion.length > 1
                ? cuotasPendientes.find(c => c.nroCuota === nuevaSeleccion[nuevaSeleccion.length - 2])
                : null;
            if (cuotaAnterior) {
                const montoCuotaAnterior = parseFloat(cuotaAnterior.montoCuota) || 0;
                const montoAcumuladoAnterior = parseFloat(cuotaAnterior.montoRendidoTotal) || 0;
                const montoIngresadoAnterior = parseFloat(montosPago[cuotaAnterior.nroCuota]) || 0;
                if (montoIngresadoAnterior + montoAcumuladoAnterior < montoCuotaAnterior) {
                    setMensajeBloqueo(`Debes completar el pago de la cuota ${cuotaAnterior.nroCuota} antes de seleccionar la siguiente.`);
                    return;
                }
            }
        }

        let nuevosMontos = { ...montosPago };

        if (!cuotasSeleccionadas.includes(cuotaId)) {
            // se selecciona → inicializar con saldo pendiente según estado
            const cuota = cuotasPendientes.find(c => c.nroCuota === cuotaId);
            if (cuota?.codEstadoCuota === ESTADO_CUOTA_RENDIDA_PARCIAL || cuota?.codEstadoCuota === ESTADO_CUOTA_VISADA_PARCIAL) {
                nuevosMontos[cuotaId] = parseFloat(cuota.montoCuota) - (parseFloat(cuota.montoRendidoTotal) || 0);
            } else {
                nuevosMontos[cuotaId] = parseFloat(cuota?.montoCuota) || 0;
            }
        } else {
            // se deselecciona → eliminar
            delete nuevosMontos[cuotaId];
        }

        setMontosPago(nuevosMontos);
        if (!cuotasSeleccionadas.includes(cuotaId)) {
            setMontosDisplay(prev => ({ ...prev, [cuotaId]: nuevosMontos[cuotaId] ? formatearNumero(nuevosMontos[cuotaId]) : '' }));
        } else {
            setMontosDisplay(prev => { const d = { ...prev }; delete d[cuotaId]; return d; });
        }

        formik.setFieldValue("cuotasSeleccionadas", nuevaSeleccion, true);
        formik.setFieldTouched("cuotasSeleccionadas", true, false);
        setCuotasSeleccionadas(nuevaSeleccion);

        const total = nuevaSeleccion.reduce((acc, id) => acc + (nuevosMontos[id] || 0), 0);
        setTotalARendir(total);
    };
    useEffect(() => {
        if (respuestaRendir && respuestaRendir['code'] == 1) {
            clearFields();
        }
    }, [respuestaRendir]);

    const clearFields = () => {
        formik.resetForm();

        formik.setFieldTouched('fileComprobante', false);     
        formik.setFieldValue('fileComprobante', '');  
        
        if (fileRefComprobante.current) {
            fileRefComprobante.current.value = '';
            formik.errors.fileComprobante='';
        }

        setMontoRendido("");
        setMedioPago("");
        setBanco("");
        setNroChequeTrx("");
        setFechaTransaccion("");
        setCuotasSeleccionadas([]);
        setMontosDisplay({});
    }

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idUsuario": "",
            "montoRendido":"",
            "medioPago":"",
            "banco":"",
            "nroChequeTrx":"",
            "fechaTransaccion":"",
            "fileComprobante":"",
            "file":"",
            "monedaRendicion":"",        
            "cuotasSeleccionadas":[]    
        },
        validationSchema: validationSchemas(),
        onSubmit: (formData) => {

            if (montoRendidoNoFormato != totalARendir) {
                formik.setErrors({ montoRendido: `El monto debe ser igual a ${totalARendir}` });
                return;
            }
            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso'];
            dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado'];
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso'];
            dataForm['idUsuario'] = Auth.currentUser()?.rutUsuario;
            dataForm['montoRendido'] = montoRendidoNoFormato;
            //dataForm['cuotasSeleccionadas'] = cuotasSeleccionadas;
            dataForm['idFolioRendicion'] = declaracionPago?.idFolioRendicion;
            dataForm['monedaRendicion'] = declaracionPago?.codMonedaLocal;

            const cuotasConMonto = cuotasSeleccionadas.map((id) => {
                const cuota = cuotasPendientes.find(c => c.nroCuota === id);
                const montoAcumulado = parseFloat(cuota?.montoRendidoTotal) || 0;
                return {
                    nroCuota: id,
                    montoPago: montosPago[id] || 0,
                    montoCuota: cuota?.montoCuota || 0,
                    montoTotalPagado: montoAcumulado
                };
            });
            dataForm['cuotasSeleccionadas'] = cuotasConMonto;
            
            const error = validarTolerancia();

            if (error) {
                formik.setErrors({"cuotasSeleccionadas": error});
                return;
            }

            setLoading(true);            
            
            const processFile = (file) => {
                return new Promise((resolve, reject) => {
                    if (!file) {
                        resolve(null);
                        return;
                    }
            
                    getBase64(file)
                        .then((base64data) => {
                            resolve({
                                filename: file.name,
                                mimetype: file.type,
                                base64data: base64data.split(',')[1], // Extrae solo el contenido base64
                            });
                        })
                    .catch((error) => reject(error));
                });
            };
            
            Promise.all([processFile(formData.fileComprobante)])
                .then(([fileComprobanteData]) => {
                    let data = { ...dataForm };
            
                    if (fileComprobanteData) {
                        data.fileComprobante = fileComprobanteData;
                    }

                    console.log("data: ", data);
            
                    serviceRendirCuota(data)
                        .then((response) => {
                            console.log("response: ", response);
                                                      
                            setRespuestaRendir(response);
                            handleShowToast(true);
                            setLoading(false);                           
                            getDeclaracionPago();
                            //delete formData.fileComprobante;
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.error(error.message);
                            alert(error.message);
                        });
            })
            .catch((error) => {
                setLoading(false);      
                console.error("Error procesando archivo:", error);
                alert("Hubo un error procesando el archivo.");
            });
        }
    })
    // 293006: acumulado = montoTotalPagado (visados CIA anteriores) + montoPagado (rendido actual pendiente de visar)
    // Evita que getSaldoMaximo muestre el saldo incorrecto cuando hay pagos visados anteriores y un pago pendiente CIA
    // Garantiza que no se pueda rendir la cuota siguiente sin agotar el saldo de la anterior
    const getMontoAcumulado = (cuota) => parseFloat(cuota.montoRendidoTotal) || 0;

    const getSaldoMaximo = (cuota) => parseFloat(cuota.montoCuota) - getMontoAcumulado(cuota);

    const validarTolerancia = () => {
        // Bloquea submit si hay cuota parcial previa (293006/293007) cuyo saldo no queda cubierto en esta rendición
        for (const id of cuotasSeleccionadas) {
            const parcialesPrevias = cuotasPendientes.filter(c =>
                c.nroCuota < id &&
                (c.codEstadoCuota === ESTADO_CUOTA_RENDIDA_PARCIAL || c.codEstadoCuota === ESTADO_CUOTA_VISADA_PARCIAL)
            );
            for (const prev of parcialesPrevias) {
                const aRendir = montosPago[prev.nroCuota] || 0;
                if (getMontoAcumulado(prev) + aRendir < parseFloat(prev.montoCuota)) {
                    return `Debe completar el pago de la cuota ${prev.nroCuota} antes de rendir la cuota ${id}.`;
                }
            }
        }

        let param51 = Number(valorParamToleranciaMonto); // 👉 Parámetro de tolerancia (10%)
        // 👉 Solo cuotas seleccionadas CON monto
        const cuotasPagadas = cuotasPendientes.filter(c => {
            const monto = montosPago[c.nroCuota];
            return (
                cuotasSeleccionadas.includes(c.nroCuota) &&
                monto !== undefined &&
                monto > 0
            );
        });

        const totalCuotas = cuotasPendientes.length;
        const totalPagadas = cuotasPagadas.length;

        // 👉 Caso 1: aún quedan cuotas pendientes
        if (totalPagadas < totalCuotas) {
            for (let c of cuotasPagadas) {
                const montoPago = montosPago[c.nroCuota];
                // Base de tolerancia = saldo pendiente según estado
                const baseTolerancia = (c.codEstadoCuota === ESTADO_CUOTA_RENDIDA_PARCIAL || c.codEstadoCuota === ESTADO_CUOTA_VISADA_PARCIAL)
                    ? parseFloat(c.montoCuota) - (parseFloat(c.montoRendidoTotal) || 0)
                    : parseFloat(c.montoCuota);

                const min = Math.round((baseTolerancia - (baseTolerancia * param51)));
                const max = Math.round(baseTolerancia * (1 + param51));

                if (montoPago < min || montoPago > max) {
                    return `La cuota ${c.nroCuota} está fuera del rango permitido (${formato_monto(min)} - ${formato_monto(max)}).`;
                }
            }
        } else {
            // 👉 Caso 2: se están pagando TODAS
            /*const saldoPendiente = cuotasPendientes.reduce(
                (acc, c) => acc + c.montoCuota,
                0
            );*/

            const totalPagado = cuotasPagadas.reduce(
                (acc, c) => acc + (montosPago[c.nroCuota] || 0),
                0
            );

            if (totalPagado !== montoSaldoCuotas) {
                return "El monto total debe ser igual al saldo pendiente.";
            }
        }

        return null;
    };
  return (
    <>
    <style type='text/css'>
        {`
        .btn-carpeta {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
        }
        .btn-carpeta:hover{
            background-color:#e1b97f;
            color: #FFFFFF;
        }
        .btn-actualizar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-actualizar:hover{
            background-color:  #F6897E;
            color: #FFFFFF;
        }
        .btn-volver {
            color: #66CCCC;
            border: 1px solid #C00
            width: 140px;
        }
    `}
      </style>
    <LoadingComponent show={loading} />
    <Form onSubmit={formik.handleSubmit}>
        <Card className="mb-3 p-3">
            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                {(cfg_form && cfg_form["rinde-cuotas-ingrend-subtitle"]) ? cfg_form["rinde-cuotas-ingrend-subtitle"] : 'Rendición Pago de Cuotas'} 
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                            {(cfg_form && cfg_form['rinde-cuotas-ingrend-input-montorendido']) ? cfg_form['rinde-cuotas-ingrend-input-montorendido'] + " *": 'Monto Rendido' + " *" } 
                        </Form.Label>
                        {' '}
                        <Form.Control
                            aria-label='Default select example'
                            autoComplete='off'
                            onKeyDown={(e) => validaNumeros(e)}
                            onBlur={() => {
                                setMontoRendido(formatearNumero(montoRendido, !codMoneda == 30001))
                            }}
                            onFocus={() => setMontoRendido(montoRendidoNoFormato)}
                            onChange={(e) => {
                                formik.handleChange(e)
                                setMontoRendido(e.target.value)
                                setMontoRendidoNoFormato(e.target.value)                                                                                                            
                            }}
                            name='montoRendido'
                            value={(formik.values.montoRendido = montoRendido)}
                            error={formik.errors.montoRendido}
                        ></Form.Control> 
                        {formik.errors.montoRendido ? (
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                {formik.errors.montoRendido}
                            </Form.Text>
                        ) : (
                            ''
                        )}
                    </Col>
                    <Col>
                        <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                            {(cfg_form && cfg_form['rinde-cuotas-ingrend-cmb-mediopago']) ? cfg_form['rinde-cuotas-ingrend-cmb-mediopago'] : 'Medio de Pago' } 
                        </Form.Label>
                        {' '}
                        <br/>
                        <Form.Select  aria-label='Default select example'
                            onChange={
                                (e) => {
                                    formik.handleChange(e)
                                    setMedioPago(e.target.value)   
                                    getBancos(e.target.value);                                              
                                }
                            }
                            name='medioPago'
                            value={(formik.values.medioPago)}
                            error={formik.errors.medioPago}>
                            <option value={''}>Seleccione...</option>
                            {mediosPago && mediosPago ?. map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.nombre} 
                                </option>
                                ))
                            } 
                        </Form.Select>
                    </Col>
                    <Col>
                        <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                            {(cfg_form && cfg_form['rinde-cuotas-ingrend-cmb-banco']) ? cfg_form['rinde-cuotas-ingrend-cmb-banco'] : 'Banco/Institución' } 
                        </Form.Label>
                        {' '}
                        <br/>
                        <Form.Select  aria-label='Default select example'
                            onChange={(e) => {
                                    formik.handleChange(e)
                                    setBanco(e.target.value)
                                }
                            }
                            name='banco'
                            value={(formik.values.banco)}
                            error={formik.errors.banco}>
                            <option value={''}>Seleccione...</option>
                            {bancos && bancos ?. map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.nombre} 
                                </option>
                                ))
                            } 
                        </Form.Select>
                        {formik.errors.banco && formik.touched.banco &&
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.banco}
                            </Form.Text>
                        }
                    </Col>
                    <Col>
                        <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                            {(cfg_form && cfg_form['rinde-cuotas-ingrend-input-nrocheque']) ? cfg_form['rinde-cuotas-ingrend-input-nrocheque'] : 'Nro.Cheque/Transacción' } 
                        </Form.Label>
                        {' '}
                        <Form.Control
                            autoComplete='off'
                            value={(formik.values.nroChequeTrx)}      
                            onChange={(e) => {
                                formik.handleChange(e)
                                setNroChequeTrx(e.target.value)
                            }}                                              
                            name='nroChequeTrx'
                            error={formik.errors.nroChequeTrx}
                        ></Form.Control>
                        {formik.errors.nroChequeTrx && formik.touched.nroChequeTrx &&
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.nroChequeTrx}
                            </Form.Text>
                        }
                    </Col>
                    <Col>
                        <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                            {(cfg_form && cfg_form['rinde-cuotas-ingrend-input-fechatrx']) ? cfg_form['rinde-cuotas-ingrend-input-fechatrx'] + " *" : 'Fecha Transacción' + " *" } 
                        </Form.Label>
                        {' '}
                        <br/>
                        <Form.Control className='mb-0' type='date'
                            value={(formik.values.fechaTransaccion)}
                            min={fechaMin && fechaMin}
                            max={hoy()}
                            name='fechaTransaccion'
                            onChange={(e) => {
                                    formik.handleChange(e)
                                    setFechaTransaccion(e.target.value)
                                }
                            }
                            error={formik.errors.fechaTransaccion}
                        >                                                    
                        </Form.Control>
                        {formik.errors.fechaTransaccion && formik.touched.fechaTransaccion &&
                            <Form.Text variant='danger' style={{ color: 'red' }}>
                            {formik.errors.fechaTransaccion}
                            </Form.Text>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col md='12'>
                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form['rinde-cuotas-ingrend-lbl-subirdctocomprobante']) ? cfg_form['rinde-cuotas-ingrend-lbl-subirdctocomprobante'] : "Seleccionar Comprobante "  + " (para mas de un comprobante, adjuntarlos en un solo archivo) *"}
                        </Form.Label>
                        <Form.Group className="position-relative mb-2 mt-1">
                            <Form.Control ref={fileRefComprobante} type="file" name="fileComprobante"
                                onChange={event => { formik.setFieldValue("fileComprobante", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.fileComprobante}
                                isValid={formik.touched.fileComprobante && !formik.errors.fileComprobante}
                            />
                            <Form.Text className="text-muted">Tamaño máximo del archivo: 5MB</Form.Text>
                            <Form.Control.Feedback type="invalid"> {formik.errors.fileComprobante} </Form.Control.Feedback>
                        </Form.Group>                                                
                    </Col>
                </Row>
                <Container>
                    <Row>
                        <Col>
                            {respuestaRendir && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={respuestaRendir}
                                ></Mensajes>
                            }
                        </Col>
                    </Row>
                </Container>
                <br/>
                {mensajeBloqueo && (
                    <Form.Text style={{ color: 'red', display: 'block', marginBottom: '8px' }}>
                        {mensajeBloqueo}
                    </Form.Text>
                )}
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Sel.</th>
                            <th>{(cfg_form && cfg_form["rinde-cuotas-ingrend-grilla-nrocuota"]) ? cfg_form["rinde-cuotas-ingrend-grilla-nrocuota"] : 'Nro. Cuota'}</th>
                            <th>{(cfg_form && cfg_form["rinde-cuotas-ingrend-grilla-fechacuota"]) ? cfg_form["rinde-cuotas-ingrend-grilla-fechacuota"] : 'Fecha Cuota'}</th>
                            <th>{(cfg_form && cfg_form["rinde-cuotas-ingrend-grilla-montocuota"]) ? cfg_form["rinde-cuotas-ingrend-grilla-montocuota"] : 'Monto Cuota'}</th>
                            <th>{(cfg_form && cfg_form["rinde-cuotas-ingrend-grilla-montopagado"]) ? cfg_form["rinde-cuotas-ingrend-grilla-montopagado"] : 'Monto Pagado'}</th>
                            <th>{(cfg_form && cfg_form["rinde-cuotas-ingrend-grilla-montoarendir"]) ? cfg_form["rinde-cuotas-ingrend-grilla-montoarendir"] : 'Monto a Rendir'}</th>
                            <th>{(cfg_form && cfg_form["rinde-cuotas-ingrend-grilla-estado"]) ? cfg_form["rinde-cuotas-ingrend-grilla-estado"] : 'Estado'}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {cuotasPendientes?.map((r) => (
                        <tr key={r.nroCuota}>
                        <td>
                        <Form.Check
                            type="checkbox"
                            checked={cuotasSeleccionadas.includes(r.nroCuota)}
                            onChange={() => toggleSeleccion(r.nroCuota)}
                            />
                        </td>
                        <td>{r.nroCuota}</td>
                        <td>{r.fechaVencimientoFmt}</td>
                        <td>{formato_monto(r.montoCuota)}</td>
                        <td>{parseFloat(r.montoTotalPagado) > 0 ? formato_monto(r.montoTotalPagado) : '-'}</td>
                        <td style={{ width: '200px' }}>
                            <Form.Control
                                type="text"
                                inputMode="numeric"
                                value={montosDisplay[r.nroCuota] ?? ''}
                                disabled={!cuotasSeleccionadas.includes(r.nroCuota)}
                                onKeyDown={(e) => validaNumeros(e)}
                                onFocus={() => {
                                    setMontosDisplay(prev => ({ ...prev, [r.nroCuota]: String(montosPago[r.nroCuota] || '') }));
                                }}
                                onBlur={() => {
                                    const raw = montosPago[r.nroCuota];
                                    setMontosDisplay(prev => ({ ...prev, [r.nroCuota]: raw ? formatearNumero(raw) : '' }));
                                }}
                                onChange={(e) => {
                                    const rawStr = e.target.value.replace(/\./g, '').replace(/[^0-9]/g, '');
                                    const saldoMax = getSaldoMaximo(r);
                                    const value = Math.min(Number(rawStr) || 0, saldoMax);
                                    const nuevosMontos = {
                                        ...montosPago,
                                        [r.nroCuota]: value
                                    };
                                    setMontosPago(nuevosMontos);
                                    setMontosDisplay(prev => ({ ...prev, [r.nroCuota]: rawStr }));
                                    const total = cuotasSeleccionadas.reduce(
                                        (acc, id) => acc + (nuevosMontos[id] || 0),
                                        0
                                    );
                                    setTotalARendir(total);
                                }}
                            />
                        </td>
                        <td>{r.estadoCuota}</td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan="3" className="text-end fw-bold">Total a Rendir:</td>
                        <td className="fw-bold">{formato_monto(totalARendir)}</td>
                        <td colSpan="3"></td>
                    </tr>
                    </tbody>                
                </Table>
                {formik.errors.cuotasSeleccionadas && formik.touched.cuotasSeleccionadas &&
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.cuotasSeleccionadas}
                    </Form.Text>
                }
            </Card.Body>
            <Row className='mt-1'>                    
                <Col className='d-flex align-items-end justify-content-end m-2'>
                    <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-ingreso-recuperos-cuota',{state:{queryState}})}>Volver</Button>
                    <Button className='m-2' variant='actualizar' type='onSubmit' >Rendir</Button>
                </Col>
            </Row>
            <Card.Footer>
                
            </Card.Footer>   
        </Card>
    </Form>
    </>
  );
};

export default RendicionCuotas;

const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
};